//@ts-check
import React, { useState, useEffect } from 'react';
import { MultiSelect } from '../../_shared';
import CheckIcon from '../../_shared/Icon/CheckIcon';
import CloseIcon from '../../_shared/Icon/CloseIcon';
import cx from 'classnames';
import { ConfirmationModal } from '../../_shared';

const FolderWorkflowConfigRowEdit = ({ config, workflows, onUpdate, onEditCancel }) => {
    const [editWorkflow, setEditWorkflow] = useState(null);
    const [editStatus, setEditStatus] = useState(null);
    const [editStatuses, setEditStatuses] = useState([]);
    const [errors, setErrors] = useState({ workflow: '', status: '' });
    const [showEditModal, setShowEditModal] = useState(false);

    useEffect(() => {
        const workflow = workflows.find((w) => w.id === config.workflowId);
        if (workflow) {
            setEditWorkflow(workflow);
            const statusOptions = (workflow.statuses || [])
                .filter((s) => s.enabled)
                .map((s) => ({
                    label: s.label || s.name,
                    value: s.id,
                    id: s.id,
                    ...s
                }));
            setEditStatuses(statusOptions);

            const currentStatus = statusOptions.find((s) => s.id === config.workflowStatusId);
            setEditStatus(currentStatus || null);
        }
    }, []);


    const handleUpdateConfirm = async () => {
        setShowEditModal(true);
        await handleSave();
    };

    const handleEditCancel = () => {
        setShowEditModal(false);
    };

    const handleWorkflowChange = (option) => {
        setEditWorkflow(option);
        setEditStatus(null);
        setErrors({ workflow: '', status: '' });

        if (option && option.statuses) {
            const statusOptions = option.statuses
                .filter((s) => s.enabled)
                .map((s) => ({
                    label: s.label || s.name,
                    value: s.id,
                    id: s.id,
                    ...s
                }));
            setEditStatuses(statusOptions);
        } else {
            setEditStatuses([]);
        }
    };

    const validate = () => {
        const next = { workflow: '', status: '' };
        if (!editWorkflow) next.workflow = 'Please select a workflow';
        if (!editStatus) next.status = 'Please select a status';
        setErrors(next);
        return !next.workflow && !next.status;
    };

    const saveClicked = () => {
        if (!validate()) return;
        
        setShowEditModal(true);

    }
    const handleSave = async () => {
        await onUpdate({
            ...config,
            workflowId: editWorkflow.id,
            workflowName: editWorkflow.name || editWorkflow.label,
            workflowStatusId: editStatus.id,
            workflowStatusName: editStatus.label || editStatus.name
        });
    };

    const handleCancel = () => {
        onEditCancel();
    };

    const errorIcon = (message) => (
        <span className="folder-workflow-edit-error-icon" title={message}>
            <i className="fas fa-exclamation-circle" />
        </span>
    );

    return (
        <div className={cx('folder-workflow-table__row', 'folder-workflow-table__row--editing')}>
            <div className="folder-workflow-table__cell folder-workflow-table__cell--icon folder-workflow-table__cell--actions">
                <a
                    className="folder-workflow-icon-btn"
                    title="Save"
                    onClick={saveClicked}>
                    <CheckIcon width={16} height={16} color="var(--primary-color)" />
                </a>
                <a
                    className="folder-workflow-icon-btn"
                    title="Cancel"
                    onClick={handleCancel}>
                    <CloseIcon width={14} height={14} />
                </a>
            </div>
            <div className="folder-workflow-table__cell">
                {config.directoryName}
            </div>
            <div className="folder-workflow-table__cell folder-workflow-table__cell--editable">
                <div className="folder-workflow-edit-field">
                    {errors.workflow && errorIcon(errors.workflow)}
                    <MultiSelect
                        isMulti={false}
                        options={workflows}
                        selectedOptions={editWorkflow ? [editWorkflow] : []}
                        onChange={handleWorkflowChange}
                        closeMenuOnSelect={true}
                        placeholder="Select Workflow"
                    />
                </div>
            </div>
            <div className="folder-workflow-table__cell folder-workflow-table__cell--editable">
                <div className="folder-workflow-edit-field">
                    {errors.status && errorIcon(errors.status)}
                    <MultiSelect
                        isMulti={false}
                        options={editStatuses}
                        selectedOptions={editStatus ? [editStatus] : []}
                        onChange={(option) => {
                            setEditStatus(option);
                            setErrors((prev) => ({ ...prev, status: '' }));
                        }}
                        closeMenuOnSelect={true}
                        placeholder="Select Status"
                    />
                </div>
            </div>
            {showEditModal && (
                <ConfirmationModal
                    show
                    onHide={handleEditCancel}
                    onPrimaryClick={handleUpdateConfirm}
                    onSecondaryClick={handleEditCancel}
                    primaryButtonText="Ok"
                    secondaryButtonText="Cancel"
                    title="Update Folder Workflow"
                    bodyText={`This change will apply to new files only. Existing files will not be affected.`}
                />
            )}
        </div>
    );
};

export { FolderWorkflowConfigRowEdit };
